<div class="user-license">
  @if (this.error()) {
    <div>
      {{ this.error()}}
    </div>
  }
  @if ((this.license$ | async) == 'invited') {
    <div style="padding-left: 40px; margin-bottom: 10px;">
      You've been invited to a FlowStudio workspace. <br>
      With this workspace, you can collaborate with your team, monitor Power Automate flows—all within FlowStudio.<br>
      <br>
        Please note after you join the team, your license will then be managed by the team admin. If you have any questions, feel free to reach out to us.<br>
        <button type="button" class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors" (click)="onJoin($event)">Join</button>
      </div>
    }
    <kendo-grid
      [kendoGridReactiveEditing]="createFormGroup"
      [kendoGridBinding]="users$ | async"
      [trackBy]="trackByIndex"
      (save)="onSave($event)"
      [pageSize]="10"
      [pageable]="true"
      [sortable]="true"
      [navigable]="true">
      <ng-template kendoGridToolbarTemplate>
        @if ((this.license$ | async) == 'admin') {
          <button kendoGridAddCommand>Add New User</button>
        }
        @if ((this.license$ | async) == 'admin') {
          <button type="button" class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors" (click)="onUpdate($event)">Update Licenses</button>
        }
        @if (false && (this.license$ | async) == 'admin') {
          <button type="button" class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors" (click)="onBuy($event)">Add More Seats</button>
        }
      </ng-template>
      <kendo-grid-column field="title" title="Email"></kendo-grid-column>
      <kendo-grid-column field="user_type" editor="text" title="User Type">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
          <kendo-dropdownlist
            [formControl]="$any(formGroup.get('user_type'))"
            [data]="this.usertypes"
          ></kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="invitation" title="Invited">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
          {{dataItem.invitation}}
        </ng-template>
      </kendo-grid-column>
      @if ((this.license$ | async) == 'admin') {
        <kendo-grid-column field="license_pro" editor="text" title="Pro License">
          <ng-template kendoGridHeaderTemplate let-column>
            <span>{{ column.title }} ({{ this.pro$ | async }}/{{ (this.workspace$ | async)?.seats_pro}})</span>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.license_pro }} @if (dataItem.license_pro_assigned) {
            <span>({{ dataItem.license_pro_assigned }})</span>
          }
        </ng-template>
        <ng-template kendoGridEditTemplate let-dataItem>
          <kendo-combobox
            [formControl]="$any(formGroup.get('license_pro'))"
            [data]="['pro']"
            [valuePrimitive]="true"
            >
          </kendo-combobox>
        </ng-template>
      </kendo-grid-column>
    }
    @if ((this.license$ | async) == 'admin') {
      <kendo-grid-column field="license_teams" editor="text" title="Teams License">
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{ column.title }} ({{ this.teams$ | async }}/{{ (this.workspace$ | async)?.seats_teams}})</span>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.license_teams }} @if (dataItem.license_teams_assigned) {
          <span>({{ dataItem.license_teams_assigned }})</span>
        }
      </ng-template>
      <ng-template kendoGridEditTemplate let-dataItem>
        <kendo-combobox
          [formControl]="$any(formGroup.get('license_teams'))"
          [data]="['teams']"
          [valuePrimitive]="true"
          >
        </kendo-combobox>
      </ng-template>
    </kendo-grid-column>
  }
  <kendo-grid-command-column title="" [width]="180">
    <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
      @if ((this.license$ | async) == 'admin') {
        <button kendoGridEditCommand themeColor="primary">Edit</button>
      }
      @if ((this.license$ | async) == 'admin') {
        <button kendoGridRemoveCommand [disabled]="dataItem.license_pro || dataItem.license_teams">Remove</button>
      }
      @if ((this.license$ | async) == 'admin') {
        <button kendoGridSaveCommand [disabled]="formGroup.invalid">
          {{ isNew ? "Add" : "Update" }}
        </button>
      }
      @if ((this.license$ | async) == 'admin') {
        <button kendoGridCancelCommand>
          {{ "Cancel" }}
        </button>
      }
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>

<!-- {{ this.users$ | async | json }}  <br>
{{ this.pro$ | async | json }}    <br>
{{ this.teams$ | async | json }}  <br>
{{ this.workspace$ | async | json }} <br> -->

@if (!(this.ready())) {
  <div class="loading">
    <div class="k-i-loading"></div>
  </div>
}

</div>
